export const columns = [
  {
    Header: 'Rut de colaborador',
    accessor: 'sRUT',
    type: 'dni', // accessor is the "key" in the data
    toEnd: true,
  },
  {
    Header: 'Número de bolsillo',
    accessor: 'sTarjeta',
    type: 'card',
  },
  {
    Header: 'Nombre del colaborador',
    accessor: 'sNombre',
  },
  {
    Header: 'Centro de costo',
    accessor: 'CentroCosto',
    toEnd: true,
  },
  {
    Header: 'Sucursal',
    accessor: 'Sucursal',
  },
  {
    Header: 'Monto a recargar',
    accessor: 'nMonto',
    type: 'currency',
    editable: true,
  },
]

export const data = [
  {
    dni: '00.000.000-0',
    acount_number: '*******0461',
    name: 'Francisco Javier Palacios',
    cost_center: 'Centro de costo A',
    branch_office: 'Sucursal 1',
    recharge_amount: '000.00',
  },
]
